import NonePng from '../../assets/png/profile.png'

interface Props {
    url?: string;
    width?: string;
}

const Avatar = ({url, width = 'width-30'}: Props) => {
    return (
        <div
            className={`${width} aspect-ratio-1 padding-5 display-flex align-items-center justify-content-center rounded-circle bg-size-100pct bg-repeat-no`}
            style={{
                backgroundImage: `url(${url || NonePng})`,
            }}
        />
    )
}

export default Avatar;